export const chapterWaiverConstants = {
    ON: 'on:',
    PROSPECTIVE_MEMBER_WAIVERS: 'Prospective Member Waivers',
    VIEW_WAIVER: 'View Waiver',
    CLOSE_WAIVER: 'Close Waiver',
    DENY: 'Deny',
    APPROVED: 'Approved',
    DENIED: 'Denied',
    MORE_INFO: 'More Info',
    LESS_INFO: 'Less Info',
    APPROVED_WAIVER: 'You have approved this waiver',
    DENY_WAIVER: 'You have denied this waiver',
    WAIVER_APPROVE: 'Approve',
    ERROR_LOADING: 'Error in loading the list of waivers. Please try reloading the page.',
    WAIVER_LIST_EMPTY: 'No waivers to display',
    CHAPTEROFFICER: 'CHAPTEROFFICER',
    PRPADMIN: 'PRPADMIN',
    REGIONALOFFICER: 'REGIONALOFFICER',
    PRPMEMBER: 'PRPMEMBER',
    FOUR: '4',
    SEND_BACK_TO_CHAPTER: 'Send Back To Chapter',
    REASON_HEADER: 'Enter a reason for sending the waiver back to the Chapter',
    ERROR_OCCURRED: 'Error Occurred',
    REQUESTED_ON: 'Requested on: ',
    WAIVER_REQUESTED_MESSAGE: 'Waiver Requested Successfully',
    BUTTON: 'Button',
    LABEL: 'Label',
    MAX_TIMEOUT: '6000',
    WAIVER_SAVED_MESSAGE: 'Waiver saved successfully',
    SAVE_AS_DRAFT: 'SAVE AS DRAFT',
    SAVE_AS_PDF: 'Save as PDF',
    ERROR_MESSAGE: 'Please fill the required details',
    WAIVER_DATE: 'Waiver Date:',
    REQUESTED: 'Requested',
    PENDING: 'Pending',
    SEND_TO_REGION: 'Send_to_Region',
    RESEND_TO_REGION: 'Resend_to_Region',
    SEND_TO_PRP: 'Send_to_PRP',
    RESEND_TO_PRP: 'Resend_to_PRP',
    RESEND_TO_REGION_BUTTON_TEXT: 'RESEND TO REGION',
    RESENT_TO_REGION_SEND_TO_PRP: 'Resend_To_Region_Send_to_PRP',
    FINALIZE: 'Finalize',
    SENT_ON: 'Sent on:',
    WAIVER_ERROR_MESSAGE:
        'Due to technical issues, we are currently unable to save your chapter waiver request. Please try again later.',
    PRP_ADMIN: 'PRP Admin',
    REGION: 'region',
    DENIAL_REASON: 'Please provide comments/feedback',
    APPROVED_BY_MEMBER: 'Approved_by_Member',
    DENIED_BY_MEMBER: 'Denied_by_Member',
    ATTACHMENT_SUCCESS: 'File(s) attached successfully',
    RESUBMIT: 'ReSubmit',
    CLEAR_FILTER: 'Clear',
    SEEALL: 'SEE ALL',
    VIEW_ALL_WAIVERS: 'View All Waivers',
    APPROVE_WAIVER: 'Approve Waiver',
    MAX_LENGTH: 15,
    DRAFT_ERROR: 'Please provide valid information',
    INSUFFICIENT_PERMISSIONS: 'Insufficient permissions to view waiverList.',
    ADMIN_ONLY_TITLE: 'Administrators Only',
    ADMIN_ONLY_TEXT: `Caring for our YPO members requires we keep some features private. Thanks for understanding. To continue please select your browser's Back button or close this tab/window.`,
};

export const waiverFormConstants = {
    TYPE_OF_WAIVER: 'Type of Waiver:',
    TYPE_OF_WAIVER_WATER_MARK: '(Age; Employee; Employee Compensation; Enterprise; Title; Volume)',
    AGE: 'Age:',
    AGE_WATER_MARK: '(Month/Day/Year)',
    COMPANY_NAME: 'Company’s Name:',
    TYPE_OF_COMPANY: 'Type of Company:',
    WHO_DO_YOU_REPORT_TO: 'Who do you report to?:',   
    COMPANY_WEBSITE: 'Company Website:',
    TITLE: 'Title:',
    NO_OF_EMPLOYEES: 'No of Employees:',
    NO_OF_EMPLOYEES_WATER_MARK: '(Number of employees is required if candidate is qualifying with Annual Compensation)',
    TOTAL_EMPLOYEE_COMP: 'Total Employee Compensation:',
    TOTAL_EMPLOYEE_COMP_WATER_MARK: '(in USD$ million)',
    DOLLAR_VALUE: 'Dollar Volume:',
    CORP_TYPE: 'Corporation Type:',
    NO_OF_MEMBERS_IN_CHAPTER: 'Number of Members in Chapter:',
    MANAGEMENT_RESEARCH: 'Management research:',
    FORM_TEXT1: 'Please complete the below section based on the',
    FORM_TEXT2: 'type of waiver',
    FORM_TEXT3: 'requested.',
    FORM_WARNING: 'Please complete all questions below.',
    FORM_QUESTION1:
        'What unique value the prospective member brings to the Chapter and YPO that justify an exception to the requirements? Please elaborate.',
    FORM_QUESTION2_PART1: 'What contribution',
    FORM_QUESTION2_PART2: '(e.g. Day Chair/Champion and event within one year)',
    FORM_QUESTION2_PART3:
        'will the prospective member bring to the Chapter and YPO that justify an exception to the requirements? Please elaborate.',
    FORM_QUESTION3: 'Additional comments or clarification on this waiver request:',
    ATTACH_DOC: 'Attach supporting documents for the Waiver',
    FORM_QUESTION4:
        'Title waivers request must be accompanied with a supporting organization chart showing the candidate as the ‘top gun’ in the company. No title request will be reviewed without a supporting organization chart.',
    MANDATORY: '*',
    TITLE_TYPE: 'Title',
    AGE_TYPE: 'Age',
    TITLE_OTHER: 'Title Other:',
    OTHER: 'other',

    // PRP Admin View
    RECOMMENDATION: 'Recommendation',
    MAX_RECOMMENDATION_LENGTH: 256,
    WAIVER_TYPE: 'Waiver Type:',
    NO_CHAPTER_MEMBERS: 'No of Chapter Members:',
    REGION_NAME: 'Region name:',
    VOLUME_SALES: 'Volume Sales:',
    TOTAL_COMP_EMP_SALES_VOL: 'Total Compensation emp and comp sales/vol:',
    IS_REQUIRED: ' is required',
    CHARACTERS: 'Characters',
    OF: 'of',
    MAX_REASON_LENGTH: 500,
    MAX_AGE: 120,
    DOB: 'Date of Birth',
    ENTERPRISE_VALUE: 'Enterprise Value:',
    ENTERPRISE_VALUE_INFO: 'If the prospect is qualifying through Volume, Enterprise Value is not needed, and may show as "0"',
};

export const waiverValidationConstants = {
    TYPE_OF_WAIVER_REQ: 'Type of waiver is required',
    AGE_ERROR: 'Please provide valid age',
    AGE_REQ: 'Age is required',
    WEBSITE_REQ: 'Website name is required',
    WEBSITE_ERROR: 'Please provide valid website name',
    COMPANY_REQ: 'Company name is required',
    TYPE_OF_COMPANY_REQ: 'Please select type of company',
    WHO_DO_YOU_REPORT_TO_REQ: 'Who do you report to is required',
    TITLE_REQ: 'Title is required',
    EMP_REQ: 'Number of employees is required',
    EMP_ERROR: 'Please provide valid number',
    EMP_COMP_REQ: 'Total employee compensation is required',
    EMP_COMP_ERROR: 'Please provide valid compensation value',
    ONE: '1',
    DOLLAR_ERROR: 'Please provide valid dollar value',
    VOLUMESALES_ERROR: 'Please provide valid volume/sales value',
    PRP_MEMBER_SELECTION_ERROR: 'Please select atleast one PRP Panel',
    CORPORATION_TYPE_REQ: 'Please select corporation type',
    DOLLAR_VALUE_REQ: 'Dollar volume is required',
    NO_OF_MEMBERS_REQ: 'Number of members in chapter is required',
    QUESTION_REQ: 'This field is required',
    ENTERPRISEVALUE_ERROR: 'Enterprise Value should be a valid number',
    REGION_NAME_REQUIRED: 'Region Name is required',
    TITLE_OTHER_REQ: 'Title other is required',
};

export const waiverFormTypesConstants = [
    { text: 'Age', value: 'Age' },
    { text: 'Employee', value: 'Employee' },
    { text: 'Employee Compensation', value: 'Employee Compensation' },
    { text: 'Enterprise', value: 'Enterprise' },
    { text: 'Title', value: 'Title' },
    { text: 'Volume', value: 'Volume' },
];

export const actionConstants = {
    CANCEL: 'Cancel',
    CONFIRM_SEND: 'Confirm And Send',
    SEND_BACK_TO_CHAPTER: 'Send Back To Chapter',
    SEND_BACK_TO_REGION: 'Send Back To Region',
    SAVE: 'Save',
    CONFIRM_AND_DENY: 'Confirm and Deny',
    SUBMIT: 'SUBMIT',
};

export const waiverBannerConstants = {
    CHAPTER_OFFICER: 'Chapter Officer',
    PEER_REVIEW_PANEL_ADMIN: 'Peer Review Panel Admin',
    PEER_REVIEW_PANEL: 'Peer Review Panel',
    REGIONAL_MEMBER_OFFICER: 'Regional Member Officer',
    REGIONAL_OFFICER: 'Regional Officer',
};

export const waiverStates = [
    { key: 'Submit', type: 'Button', value: 'SUBMIT' },
    { key: 'ReSubmit', type: 'Label', value: 'Sent Back to Chapter' },
    { key: 'Send_to_Region', type: 'Button', value: 'SEND TO REGION' },
    { key: 'Resend_to_Region', type: 'Button', value: 'RESEND TO REGION' },
    { key: 'Send_to_PRP', type: 'Button', value: 'SEND TO PRP' },
    { key: 'Resend_to_PRP', type: 'Button', value: 'RESEND TO PRP' },
    { key: 'Finalize', type: 'Button', value: 'FINALIZE' },
    { key: 'Approved', type: 'Label', value: 'Waiver Approved' },
    { key: 'Denied', type: 'Label', value: 'Waiver Denied' },
    { key: 'Resend_To_Region_Send_to_PRP', type: 'Button', value: 'SEND TO PRP' },
    { key: 'Approved_by_Member', type: 'Label', value: chapterWaiverConstants.APPROVED_WAIVER },
    { key: 'Denied_by_Member', type: 'Label', value: chapterWaiverConstants.DENY_WAIVER },
];

export const validationRules = {
    typeOfWaiverRule: [v => !!v || waiverValidationConstants.TYPE_OF_WAIVER_REQ],
    ageRule: [
        v => !v || /^(0|[1-9][0-9]*)?$/.test(v) || waiverValidationConstants.AGE_ERROR,
        v => v <= waiverFormConstants.MAX_AGE || waiverValidationConstants.AGE_ERROR,
        v => !(!v && v.length < waiverValidationConstants.ONE) || waiverValidationConstants.AGE_REQ,
    ],
    companyNameRule: [v => !!v || waiverValidationConstants.COMPANY_REQ],
    typeOfCompanyRule: [v => !!v || waiverValidationConstants.TYPE_OF_COMPANY_REQ],
    WhoDoYouReportToRule: [v => !!v || waiverValidationConstants.WHO_DO_YOU_REPORT_TO_REQ],
    titleRule: [v => !!v || waiverValidationConstants.TITLE_REQ],
    titleOtherRule: [v => !!v || waiverValidationConstants.TITLE_OTHER_REQ],
    employeesRule: [
        v => /^(0|[1-9][0-9]*)?$/.test(v) || waiverValidationConstants.EMP_ERROR,
        v => !(!v && v.length < waiverValidationConstants.ONE) || waiverValidationConstants.EMP_REQ,
    ],
    totalEmployeeRule: [
        v => !v || /^(0|[1-9][0-9]*)?$/.test(v) || /^\d{1,3}(,\d{3})*(\.\d+)?$/.test(v) || waiverValidationConstants.EMP_COMP_ERROR,
        v => !(!v && v.length < waiverValidationConstants.ONE) || waiverValidationConstants.EMP_COMP_REQ,
    ],
    websiteUrlRule: [
        v =>
            !v ||
            /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9A-Z]+([-.]{1}[a-z0-9A-Z]+)*\.[a-zA-Z]{2,10}(:[0-9]{1,5})?(\/.*)?$/.test(v) ||
            waiverValidationConstants.WEBSITE_ERROR,
        v => !!v || waiverValidationConstants.WEBSITE_REQ,
    ],
    dollarRule: [
        v => !v || /^(0|[1-9][0-9]*)?$/.test(v) || /^\d{1,3}(,\d{3})*(\.\d+)?$/.test(v) || waiverValidationConstants.DOLLAR_ERROR,
        v => (!!v && !v.length < waiverValidationConstants.ONE) || waiverValidationConstants.DOLLAR_VALUE_REQ,
    ],
    numericRule: [
        v => !v || /^(0|[1-9][0-9]*)?$/.test(v) || waiverValidationConstants.EMP_ERROR,
        v => !(!v && v.length < waiverValidationConstants.ONE) || waiverValidationConstants.NO_OF_MEMBERS_REQ,
    ],
    volumeSales: [v => !v || /^[+-]?(?=.?\d)\d*(\.\d{0,9})?$/.test(v) || waiverValidationConstants.VOLUMESALES_ERROR],
    corporationTypeRule: [v => !!v || waiverValidationConstants.CORPORATION_TYPE_REQ],
    question_Rule: [v => !!v || waiverValidationConstants.QUESTION_REQ],
    enterpriseValueRule: [
        v => !v || /^(0|[1-9][0-9]*)?$/.test(v) || /^\d{1,3}(,\d{3})*(\.\d+)?$/.test(v) || waiverValidationConstants.ENTERPRISEVALUE_ERROR,
    ],
    regionName_Rule: [v => !!v || waiverValidationConstants.REGION_NAME_REQUIRED],
};

export const RegionalViewConstants = {
    REASON_HEADER: 'Please give your comments',
    ERROR_OCCURRED: 'Error Occurred',
};

export const waiverDialogConstants = {
    TO: 'TO: ',
    CC: 'CC: ',
    SUBJECT: 'SUBJECT',
    STATUS_OF_THE_WAIVER: 'STATUS OF THE WAIVER',
    WAIVER_FOR: 'Waiver for lead',
    HAS_BEEN: 'has been',
    EMAIL_TEMPLATE: 'Email Template',
    NO_RESULTS: 'No Results to display',
};

export const sortItems = [
    { text: 'Last Updated', value: 0 },
    { text: 'First Name', value: 1 },
    { text: 'Last Name', value: 2 },
];

export const filterItems = [
    { text: 'Select Filter', value: 0 },
    { text: 'New', value: 1 },
    { text: 'Resend To Region', value: 2 },
    { text: 'Send To PRP', value: 3 },
    { text: 'Resend To PRP', value: 4 },
    { text: 'Finalize', value: 5 },
];

export const selectFinalStatus = [
    'Approve Waiver',
    'Deny Waiver',
];

export const finalizeWaiverBody = {
    DENY_WAIVER: `<body contenteditable="true" style="height: auto; min-height: auto;" class="cke_editable cke_editable_themed cke_contents_ltr cke_show_borders" spellcheck="false"><p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif">Thank you for pursuing this waiver request. <span style="color:black">Your request for an exception to the YPO membership criteria was thoughtfully reviewed by the Peer Review Panel. The committee members have concluded that they are </span><b><span style="color:#0000cc">not able to support</span></b><span style="color:black"> this exception. </span></span></span><br></p><p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span style="color:black">Appeal of a PRP decision by the Chapter Chair is permitted if the Chapter leadership has clarifying points and/or more information to share that adds to the initial submission that was not readily available at the time of the initial submission.</span></span></span><br></p><p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"><span style="color:black">We appreciate your chapter’s pursuit on behalf of your prospect and encourage you to present other such requests in the future. </span>Please contact me at +5255 4344 2538 or <a data-cke-saved-href="mailto:waivers@ypo.org" href="mailto:waivers@ypo.org" style="color:#0563c1; text-decoration:underline">waivers@ypo.org</a> if you have any questions.</span></span></p></body>`,
    APPROVE_WAIVER: `<body contenteditable="true" style="height: auto; min-height: auto;" class="cke_editable cke_editable_themed cke_contents_ltr cke_show_borders" spellcheck="false"><p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif">Thank you for pursuing this waiver request.&nbsp; The Peer Review Panel has voted to <b>approve </b>this waiver request. </span></span></p><p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif">We have the prospect’s online application. We will review and follow up with you if additional information is needed. </span></span></p><p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif">Please keep in mind the waiver is only valid for 90 days upon the approval date.</span></span><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif"></span></span><br></p><p><span style="font-size:11pt"><span style="font-family:Calibri,sans-serif">Please reach out to <a data-cke-saved-href="mailto:waivers@ypo.org" href="mailto:waivers@ypo.org" style="color:#0563c1; text-decoration:underline">waivers@ypo.org</a> if you have any questions.</span></span></p></body>`,
};

export const printForm = (waiverDetails) => {
    document.title = "";
    let documentTitle = null;
    if (waiverDetails && waiverDetails.typeOfWaiver) {
        documentTitle = `${waiverDetails.typeOfWaiver} ${waiverDetails.firstName} ${waiverDetails.lastName} ${waiverDetails.chapterName}`;
    } else {
        documentTitle = `${waiverDetails.firstName} ${waiverDetails.lastName} ${waiverDetails.chapterName}`;
    }
    document.title = documentTitle;
    document.execCommand('print');
};
